

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface VaccineParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface Vaccine {
    id?: any;
    name:any;
    tenantId: any;
    branchId: any;
    isActive:string;
    snomedCode?:number;
    parameters?: VaccineParameter[];
    links?: any;
    snomedDisplay?: string;
}


export abstract class VaccineData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<Vaccine[]>;
    abstract create(url: string, data: Vaccine): Observable<Vaccine[]>;
    abstract update(url: string, data: Vaccine): Observable<Vaccine>;
    abstract delete(url: string): Observable<any>;
}
